import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Section } from './Section';
import { IColumnSectionEntry } from '../../../../contentful/types/IColumnSectionEntry';
import { Row } from '../../../../ui';
import { SectionList } from './SectionList';
import Subheading from '../../../../components/common/headings/Subheading';

interface IColumnSectionProps {
	section: IColumnSectionEntry;
}

export default function ColumnSection({ section }: IColumnSectionProps) {
	const {
		subtitle,
		leftColumnTitle,
		leftColumn,
		rightColumnTitle,
		rightColumn,
	} = section.fields;

	return (
		<Section>
			{subtitle && <Subheading type="h3">{subtitle}</Subheading>}

			<CustomRow>
				<StyledColumn hasColumnTitle={!!leftColumnTitle}>
					{leftColumnTitle && <ColumnTitle>{leftColumnTitle}</ColumnTitle>}

					<SectionList sections={leftColumn} />
				</StyledColumn>

				<StyledColumn hasColumnTitle={!!rightColumnTitle}>
					{rightColumnTitle && <ColumnTitle>{rightColumnTitle}</ColumnTitle>}

					<SectionList sections={rightColumn} />
				</StyledColumn>
			</CustomRow>
		</Section>
	);
}

const StyledColumn = styled.div<{
	hasColumnTitle: boolean;
}>`
	${({ hasColumnTitle }) =>
		!hasColumnTitle &&
		css`
			section {
				padding-top: 0;
			}
		`}
`;

const ColumnTitle = styled.h3`
	margin-bottom: 0;
`;

const CustomRow = styled(Row)`
	section {
		margin: 0;
	}
`;
